import { kebabCase } from 'lodash-es'

export default function (selector, obj, fontContainer = false) {
  const css = []

  if (!obj) return ''

  Object.entries(obj).forEach(([ rule, value ]) => {
    if (rule === 'fontVariant') return
    if (value === 'inherit') return
    if (value === 'unset') return
    css.push([ kebabCase(rule), value ].join(':'))
  })

  if (fontContainer && obj.fontFamily) {
    if (fontContainer[obj.fontFamily]) {
      fontContainer[obj.fontFamily].add(obj.fontVariant)
    } else {
      fontContainer[obj.fontFamily] = new Set([ obj.fontVariant ])
    }
  }

  return [
    selector, '{',
    css.join(';'),
    '}'
  ].join('')
}
